import type { GrowthCategory } from '@mc/api'
import { useStaticData } from '@mc/static-data-react'

import { PrimaryCategoryAndSubcategory } from 'libs/server/api'

import { CategoryButton } from './CategoryButton'

export const CMPageCategoryButton = (props: {
  category: GrowthCategory
  order: number
}) => {
  const { primaryGrowthCatAndSubcat } = useStaticData<{
    primaryGrowthCatAndSubcat: PrimaryCategoryAndSubcategory
  }>()
  return (
    <CategoryButton
      {...props}
      currentCategory={primaryGrowthCatAndSubcat.primaryCategory}
    />
  )
}
